import { USERS_ROUTES } from '../../constants/_routes'
import usersTypes from '../../constants/usersTypes'
import { axios } from '../../services'

const create_user_request = () => {
  return {
    type: usersTypes.create.request
  }
}

const create_user_success = (response) => {
  return {
    type: usersTypes.create.success,
    payload: response.data.user
  }
}

const create_user_failure = (messages) => {
  return {
    type: usersTypes.create.failure,
    payload: messages
  }
}

const create_user = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_user_request())

    // Request
    axios.post(
      USERS_ROUTES.create,
      values
    ).then( response => {
      // success
      dispatch( create_user_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating user."]
      }
      window.showSnackbar('error', errors)
      dispatch( create_user_failure(errors))
    })
  }

}

export {
  create_user
}



// WEBPACK FOOTER //
// ./src/js/actions/users/create.js